export const CARDTYPE_STANDARD = 'Card Standard'
export const CARDTYPE_PREVIEW = 'Card Preview'



// WEBPACK FOOTER //
// ./src/constants/cardConstants.js